/*eslint-disable */
import request from '../../Utils/curl'

let TPrepResults = {
  /**
   * tprepAttemptList
   */
  async tprepAttemptList (context, subjectModuleObj, whereFilter=null) {
    try{
      let post_data = new FormData();
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }
      if (subjectModuleObj.gide_user_id) {
        post_data.append('gide_user_id', subjectModuleObj.gide_user_id)
      }
      post_data.append('app_id', subjectModuleObj.app_id)
      return await request.curl(context, "tprep_attempt_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at tprepAttemptList() and Exception:',err.message)
    }
  },
  /**
   * tprepAttemptDelete
   */
  async tprepAttemptDelete (context, deleteObj) {
    try {
      let post_data = new FormData();
      post_data.append('user_id', deleteObj.user_id);
      post_data.append('acc_id', deleteObj.acc_id || 1);
      post_data.append('aprs_id', deleteObj.aprs_id);
      post_data.append('attempt', deleteObj.attempt);

      return await request.curl(context, "tprep_attempt_delete", post_data)
        .then(async response => {
          return response;
        });
    }
    catch (err) {
      console.error('Exception occurred at tprepAttemptDelete() and Exception:', err.message);
    }
  }
}

export {
  TPrepResults
}
